import type { Ref } from 'react';

interface LogoProps {
  className?: string;
  ref?: Ref<SVGSVGElement>;
}

export const Logo = (props: LogoProps) => {
  const { className, ref } = props;

  return (
    <svg
      ref={ref}
      className={className}
      viewBox="0 0 595.3 841.9"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="GymSatellite"
    >
      <g fill="#18456B">
        <path d="M176.7,67.6v38.6c-22.5-10.9-44.6-16.3-66.1-16.3c-20.8,0-36.8,5.2-48,15.7c-11.2,10.5-16.8,23.8-16.8,40c0,15.5,5.6,28.1,16.8,37.7c11.2,9.6,26,14.4,44.3,14.4c9.7,0,19.5-2.1,29.3-6.3v-20.6h-25.6v-32.4h69.8v72.3c-7,7-17.7,12.7-32,17.2c-14.3,4.4-28.5,6.6-42.5,6.6c-30.8,0-56.1-8.5-75.9-25.5c-19.8-17-29.7-38.6-29.7-64.9c0-26.8,9.9-48.7,29.7-65.7C49.8,61.5,75.5,53,106.9,53C132.9,53,156.2,57.9,176.7,67.6z" />
        <path d="M268.8,232.2v-82.5L199,55.3h53.4l38.4,55.6l38.5-55.6h53.3l-69.8,94.4v82.5H268.8z" />
        <path d="M497.5,120.9l56.9-65.6h38.3v176.9h-44.1V121.8l-47.8,55.5h-6.6l-47.8-55.5v110.4h-44.1V55.3h38.3L497.5,120.9z" />
      </g>
      <path
        fill="#126A8F"
        d="M337.5,647.4l22.2-91.6c12.2-50.6,35.9-78.4,71.9-78.1c13.2,0.1,25.3,3.4,35.9,9.5c27.3,15.7,44.4,50.1,44,97.3c-0.6,67.4-36.2,108.2-85.7,111.9l-0.9,96.4c93.4-0.8,169.1-77.6,170.3-206.2c0.7-78.5-26.6-142.3-73.4-178.4c-5.5-4.2-11.2-8.1-17.2-11.5c-22.9-13.1-49.4-20.4-78.9-20.7c-25-0.2-47.2,4.4-66.5,13.2c-45.7,20.9-75.7,65.6-91,126.9l-22.6,92c-14.8,60.6-37.3,89.3-78.7,88.9c-13.8-0.1-26.3-3.4-37.2-9.7c-28.4-16.3-45.6-52.9-45.1-105.9c0.6-64.9,29.6-108.8,71.7-121.2c0.1,0,0.1-0.1,0.3-0.1c4.9-1.6,17.1-3.8,23.3-4.9c5.6-1,18.5-4.5,21-5.2c57.2-19.2,81.7-60.9,89-89c0-0.1,0-0.2,0.1-0.3c0.3-1.1,0.5-2.1,0.8-3.2c2.9-13,1.8-22.5-1.3-24.3c-1-0.5-2.1-0.4-3.4,0.6c-4.8,3.7-11.2,7-18.1,9.9c-1.8,0.8-3.7,1.5-5.6,2.2c-0.1,0-0.1,0-0.2,0.1c-1.9,0.7-3.8,1.4-5.7,2c-13.1,4.4-26.1,7.2-32.7,8.2c-8.5,1.2-32.2,1.6-49.5,2.2l0,0c-3.7,0.1-7.4,0.3-11.1,0.5c-2.4,0.2-4.4,0.3-5.8,0.5l0,0C70,369.1,1.2,441.6,0,573.9c-0.9,98.9,34,169.2,91.9,202.5c24.2,13.9,52.4,21.3,83.7,21.6C268.6,798.8,314.4,742.3,337.5,647.4z"
      />
    </svg>
  );
};
